import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  adjustedGradeHeader: {
    id: 'gradebook.GradesView.EditModal.Overrides.adjustedGradeHeader',
    defaultMessage: 'Adjusted grade',
    description: 'Edit Modal Override Table Adjusted grade column header',
  },
  dateHeader: {
    id: 'gradebook.GradesView.EditModal.Overrides.dateHeader',
    defaultMessage: 'Date',
    description: 'Edit Modal Override Table Date column header',
  },
  graderHeader: {
    id: 'gradebook.GradesView.EditModal.Overrides.graderHeader',
    defaultMessage: 'Grader',
    description: 'Edit Modal Override Table Grader column header',
  },
  reasonHeader: {
    id: 'gradebook.GradesView.EditModal.Overrides.reasonHeader',
    defaultMessage: 'Reason',
    description: 'Edit Modal Override Table Reason column header',
  },
});

export default messages;
